export const checkDataSourceAvailability = async chainId => {
  return true;
};
